import React from 'react';
import * as S from './cupom-skeleton.molecule.style';

export const CouponSectionSkeleton: React.FC = () => {
  return (
    <S.CouponSkeletonContainer>
      <S.CouponToggleSkeleton />
      <S.CouponButtonSkeleton />
    </S.CouponSkeletonContainer>
  );
};
